import React, { FC } from "react"
import ClipLoader from "react-spinners/ClipLoader"
import { Wrapper, LoaderType } from "./style"

interface ILoader extends LoaderType {
  color?: string,
  inline?: boolean
}
export const Loader: FC<ILoader> = ({ color='#1e90ff', inline=false }) => {
  return (
    <Wrapper $inline={inline}>
      <ClipLoader size={50} color={color} loading={true} />
    </Wrapper>
  )
}
